import { FinancialStatementItem } from './FinancialStatementItem';
import { FsSums } from '../../utils/common/FsSums';

// this class is not saved in backend
export class FinancialStatementPart {
  public constructor(
    public partName?: PartName,
    public financialStatementItems?: FinancialStatementItem[],
    public sums?: FsSums,
  ) {
    this.sums = sums ?? new FsSums();
  }

  sortItemsByOrder(): void {
    this.financialStatementItems = this.financialStatementItems.sort((a,b) => a.orderNumber - b.orderNumber);
  }

  resetPartSums(): void {
    this.sums.resetAllSums();
  }

  findSums(selectedBSDateColumns: string[]): void {
    this.resetPartSums();
    if (selectedBSDateColumns) {
      this.sums.setDateColumnSumsKeys(selectedBSDateColumns);
    }
    this.financialStatementItems.forEach((item) => {
      // used in P&L
      item.sums.quarterlySums.forEach((itemSum, quarter) => {
        const currentQuarterSum = this.sums.quarterlySums.get(quarter) || 0;
        const newQuarterSum = currentQuarterSum + itemSum;
        this.sums.quarterlySums.set(quarter, newQuarterSum);
      });
      // used in assembly
      this.sums.balance += item.sums.balance;
      this.sums.sumITP += item.sums.sumITP;
      this.sums.sumITPrevYear += item.sums.sumITPrevYear;
      this.sums.sumITYearBeforePrev += item.sums.sumITYearBeforePrev;
      // used in BS
      if (selectedBSDateColumns) {
        this.updateDateColumnSums(item);
      }
    });
    this.sums.calculateYearlySums();
    this.sumManualEntriesForPart();
  }

  sumManualEntriesForPart(): void {
    this.sums.manualCredit = 0;
    this.sums.manualDebit = 0;
    this.financialStatementItems?.forEach((item) => {
      this.sums.manualCredit += item.sums.manualCredit;
      this.sums.manualDebit += item.sums.manualDebit;
    });
  }

  /**
   * Updates the date column sums for the financial statement account based on its general ledger transactions.
   * The date column sums are stored as key-value pairs in the this.sums.dateColumnSums map.
   * If a transaction's date is on or before a specific date key, it will be added to the total sum for the corresponding column.
   *
   * @param item The financial statement account for which to update the date column sums.
   */
  private updateDateColumnSums(item: FinancialStatementItem): void {
    for (const [columnDate, currentValue] of this.sums.dateColumnSums) {
      if (item.sums.dateColumnSums.get(columnDate)) {
        this.sums.dateColumnSums.set(columnDate, (currentValue ?? 0) + item.sums.dateColumnSums.get(columnDate));
      }
    }
  }
}

export const PART_NAMES = ['Assets', 'Liabilities', 'Partners capital', 'Losses', 'Profits'] as const;
export type PartName = typeof PART_NAMES[number];
